<template>
  <span></span>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      slowHintTimer: null,
      toastEl: null,
      toastClosed: false,
    };
  },
  computed: {
    ...mapState(["ui"]),
    isLoadingTimes() {
      return !!(this.ui && this.ui.loading && this.ui.loading.times);
    },
    isArmed() {
      return !!(this.ui && this.ui.loading && this.ui.loading.slowNextAvailableToastArmed);
    },
  },
  watch: {
    isLoadingTimes() {
      this.sync();
    },
    isArmed() {
      this.sync();
    },
  },
  mounted() {
    this.sync();
  },
  beforeDestroy() {
    this.clearTimer();
    this.hideToast();
  },
  methods: {
    clearTimer() {
      if (this.slowHintTimer) {
        clearTimeout(this.slowHintTimer);
        this.slowHintTimer = null;
      }
    },
    disarm() {
      if (this.ui && this.ui.loading) {
        this.ui.loading.slowNextAvailableToastArmed = false;
        this.ui.loading.slowNextAvailableToastSource = null;
      }
    },
    sync() {
      // If we are not armed or not loading, ensure everything is cleaned up.
      if (!this.isArmed || !this.isLoadingTimes) {
        this.toastClosed = false;
        this.clearTimer();
        this.hideToast();
        if (!this.isLoadingTimes) {
          // Loading finished -> disarm (prevents accidental toast on unrelated loads)
          this.disarm();
        }
        return;
      }

      // Armed + loading -> schedule toast after 3s
      this.toastClosed = false;
      this.hideToast();
      this.clearTimer();
      this.slowHintTimer = setTimeout(() => {
        this.showToast();
      }, 3000);
    },
    showToast() {
      if (!this.isArmed || !this.isLoadingTimes || this.toastClosed) return;
      if (typeof document === "undefined") return;
      if (this.toastEl) return;

      const wrap = document.createElement("div");
      wrap.className = "nk-next-available-toast";
      wrap.setAttribute("role", "status");
      wrap.setAttribute("aria-live", "polite");

      const msg = document.createElement("div");
      msg.className = "nk-next-available-toast__message";
      msg.textContent = "Letar efter nästa lediga tid… det kan ta några sekunder.";

      const close = document.createElement("button");
      close.type = "button";
      close.className = "nk-next-available-toast__close";
      close.setAttribute("aria-label", "Stäng");
      close.textContent = "×";
      close.addEventListener("click", () => {
        this.toastClosed = true;
        this.hideToast();
      });

      wrap.appendChild(msg);
      wrap.appendChild(close);

      document.body.appendChild(wrap);
      this.toastEl = wrap;
    },
    hideToast() {
      if (!this.toastEl) return;
      try {
        if (this.toastEl.parentNode) {
          this.toastEl.parentNode.removeChild(this.toastEl);
        }
      } catch (e) {}
      this.toastEl = null;
    },
  },
};
</script>



